angular.module('impactx.supplierbasket').service('SupplierBasketService', SupplierBasketService);

SupplierBasketService.$inject = ['dataGen', '$context', '$q'];

function SupplierBasketService(dataGen, $context, $q) {

    function deactivateActiveSupplierBasket() {
        if($context.hasSupplierBasket && $context.hasSupplierBasket.value) {
            return dataGen.postAsForm({}, {}, "/supplierbasket/deactivate");
        }
        else {
            return $q.when();
        }
    }

    return {
        deactivateActiveSupplierBasket: deactivateActiveSupplierBasket
    };
}